const colors = {
  lavender: /*             */ '#C1AEF9',
  lavenderDark: /*         */ '#7F64D8',
  orange: /*               */ '#ffa92c',
  deepOrange: /*           */ '#d46a20',
  whiteGrey: /*            */ '#FCFCFD',
  periwinkle: /*           */ '#4667C8',
  periwinkleLighter: /*    */ '#C9D3F3',
  periwinkleDark: /*       */ '#3955A7',
  periwinkleDarker: /*     */ '#30437E',
  aqua: /*                 */ '#43c6f4',
  warning: /*              */ '#d35a53',
  warningDark: /*          */ '#ad1b13',
  success: /*              */ '#57779E',
  successDark: /*          */ '#0b8a11',
  darkBlue: /*             */ '#181a33',
  darkPurple: /*           */ '#2b3762',
  royalBlue: /*            */ '#060434',
  mediumPurple: /*         */ '#64649e',
  greyBlue: /*             */ '#506585',
  blueGrey: /*             */ '#414d7a',
  lightGreyBlue: /*        */ '#57779e',
  brightRichBlue: /*       */ '#0092cc',
  richBlue: /*             */ '#006e99',
  teal: /*                 */ '#063f56',
  mildBlue: /*             */ '#86b2c3',
  black: /*                */ '#111111',
  darkGrey: /*             */ '#202020',
  deepGrey: /*             */ '#34363B',
  grey: /*                 */ '#525252',
  lightGrey: /*            */ '#6a6a79',
  midGrey: /*              */ '#929191',
  dimGrey: /*              */ '#aaaaaa',
  softGrey: /*             */ '#7d8da5',
  softMidGrey: /*          */ '#7B7E92',
  lightPurple: /*          */ '#b0b0ca',
  midLightGrey: /*         */ '#cccccc',
  superLightGrey: /*       */ '#dbdbdb',
  reallyLightPurple: /*    */ '#dfdfec',
  superLightPurple: /*     */ '#ededf2',
  lightBlue: /*            */ '#eef2f6',
  lightBlue2: /*           */ 'rgba(0, 0, 0, 0.08)',
  glitter: /*              */ '#E6EBF5',
  reallyLightBlue: /*      */ '#f7f7f7',
  white: /*                */ '#ffffff',
  ghostLight: /*           */ 'rgba(255, 255, 255, 0.12)',
  ghost: /*                */ 'rgba(255, 255, 255, 0.23)',
  midGhost: /*             */ 'rgba(255, 255, 255, 0.3)',
  midWhite: /*             */ 'rgba(255, 255, 255, 0.4)',
  ghostWhite: /*           */ 'rgba(255, 255, 255, 0.5)',
  ghostDark: /*            */ 'rgba(0, 0, 0, 0.02)',
  ghostBlack: /*           */ 'rgba(0, 0, 0, 0.2)',
  ghostGrey: /*            */ 'rgba(0, 0, 0, 0.3)',
  ghostDeep: /*            */ 'rgba(0, 0, 0, 0.4)',
  ghostBlock: /*           */ 'rgba(0, 0, 0, 0.75)',
  lpBlue: /*               */ '#070737',
  lpGhost: /*              */ 'hsla(0,0%,100%,.1)',
  lpGhostSoft: /*          */ 'hsla(0,0%,100%,.05)',
  greyDarker: /*           */ '#2C3249',
  cyan: /*                 */ '#BBECFC',
  cyanDarker: /*           */ 'rgba(255, 255, 255, 0.08)',
  greyMiddle: /*           */ '#82858F',
  ghostSuperLight: /*      */ 'rgba(252,252,253,0.1)',
  greyLight: /*            */ '#C5C7CE',
  charcoal: /*             */ '#2F315F',
  brightCerulean: /*       */ '#2DBAE6',
  brightCeruleanLight: /*  */ '#2dbae61a',
  lavenderGray: /*         */ 'rgba(195, 199, 217, 0.2)',
  isabelline: /*           */ '#EBECEF',
  charcoal2: /*            */ '#2D375F',
  auroMetalSaurus: /*      */ '#6F737C',
  paynesGrey: /*           */ '#42446D',
  davysGrey: /*            */ '#485065',
  quartz: /*               */ '#494B51',
  hawkesBlue: /*           */ '#D6DAE6',
  skyBlue: /*              */ '#81D4EE',
  solitude: /*             */ '#F0F2FA',
  midnightExpress: /*      */ '#091043',
  // buttons
  safetyOrange: /*         */ '#FB6500',
  tenne: /*                */ '#C1570A',
  uclaBlue: /*             */ 'rgba(93, 103, 142, 0.75)',
  darkSlateBlue: /*        */ 'rgba(63, 76, 115, 0.75)',
  modalDarkBackground: /*  */ '#191943',
  pastelBlue: /*           */ '#B8BFD4',
  lavenderGrey: /*         */ '#C3C7D9',
  cloud: /*                */ '#A7ACBE',
  redDark: /*              */ '#AC1B20',
  redLight: /*             */ '#F29295',
  red: /*                  */ '#D72329',
  greyLighter: /*          */ '#DBDCE1',
  greyLighter2: /*         */ '#FFBDAD',
  blackTrue: /*            */ '#000000',
  rust: /*                 */ '#A64401',
  burntUmber: /*           */ '#813418',
  darkSalmon: /*           */ '#E79A7E',
  comet: /*                */ '#535677',
  // borders
  whiteSmoke: /*           */ '#F1F1F1',
  summerSky: /*            */ '#32C6F4',
  dimGray: /*              */ '#666666',
  pacificBlue: /*          */ '#0B9FCD',
  spindle: /*              */ '#BBC0C9',
  mariner: /*              */ '#4661AE',
  // fonts
  nobel: /*                */ '#9B9B9B',
  silver: /*               */ '#C1C1C1',
  blackDark: /*            */ '#0A0A0A',
  navy: /*                 */ '#1D2553',
  blackRussian: /*         */ '#020627',
  harleyDavidsonOrange: /* */ '#DB3B00',
};

const lpColorsDark = {
  graya9: '#a9afba',
  grayad: '#adadad',
  graya7: '#a7afba',
  grayf3: '#f3f6ff66',
  gray59: '#595a80',
  gray6d: '#6D6D88',
  gray62: '#626a87',
  redff7: '#ff7a7a',
  blue3f: '#3f5b92',
  blue5b: '#5b667c',
  blue5d: '#5daedc',
  blue90: '#9092bc',
  blue93: '#93aad6',
  bluebd: '#bdc6d1',
  bluebf: '#bfcade',
  green98: '#98c002',
  purpleab: '#ab47bc',
  orangef5: '#f5a623',
  orangee3: '#e3690c',
  blue32: '#32c6f4',
};

const lpColorsLight = {
  gray66: '#666666',
  gray98: '#98999b',
  gray88: '#888888',
  grayad: '#adadad',
  graya9: '#a9afba',
  grayb1: '#b1b1b1',
  green98: '#98c002',
  blue16: '#161c4f',
  blue3f: '#3f5b92',
  blue4b: '#4b91b9',
  blue58: '#5879da',
  blue5b: '#5b667c',
  blue5d: '#5daedc',
  blue94: '#94b5dd',
  bluecc: '#ccd2e3',
  redc1: '#c1272d',
  reddd: '#dd1f27',
  orangef5: '#f5a623',
  whited8: '#d8d8d8',
};

export { colors, lpColorsDark, lpColorsLight };
